import React, { useEffect, useState } from 'react'
import _get from 'lodash/get'
import { Select, InputNumber, Button, Form, Input, Layout, Modal, Row, Col } from 'antd'
import { clientRace, clientResults } from './client'
import { queryEvents, queryPaticipant, queryRaces } from './query'
import { mutationEcer } from './mutation'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
}

function useFetch(client) {
  const [data, setDate] = useState([])
  const [loading, setLoading] = useState(true)

  async function fetchUrl(query, variable = {}) {
    try {
      const results = await client.request(query, variable)
      setDate(results)
      setLoading(false)
    } catch (err) {
      console.error(err)
    }
  }

  return [fetchUrl, data, loading]
}

function CreateEcer() {
  const [fetchEvent, { events }, loadingEvent] = useFetch(clientRace)
  const [fetchTicket, { eventTicketItemSearch }] = useFetch(clientRace)
  const [fetchRace, { races }] = useFetch(clientResults)
  const [fetchEcer/* , { generateEcer }  */] = useFetch(clientResults)
  const [slug, setSlug] = useState('')
  const [eventId, setEventId] = useState('')
  const [bib, setBib] = useState('')
  const [race, setRace] = useState('')
  const [disabled, setDisabled] = useState(true)

  useEffect(() => {
    fetchEvent(queryEvents)
  }, [])

  useEffect(() => {
    if (bib && eventId) {
      fetchTicket(queryPaticipant, {
        eventId,
        search: bib,
      })
    }
  }, [eventId, bib])

  useEffect(() => {
    if (eventId) {
      fetchRace(queryRaces, { slug })
    }
  }, [eventId])

  useEffect(() => {
    const firstName = _get(eventTicketItemSearch, '0.participant.profile.firstName', false)
    if (eventId && bib && race && firstName) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [eventId, bib, race, eventTicketItemSearch])

  function handleBib(e) {
    setBib(e)
  }

  function handSubmit(e) {
    e.preventDefault()
    const record = {
      bib: bib.toString(),
      race,
      name: e.target.name.value,
    }
    Modal.confirm({
      title: 'Please be careful !',
      content: `Slug ${slug} Bib ${record.bib} Name ${record.name} ?`,
      onOk: () => fetchEcer(mutationEcer, { slug, record }),
    })
  }

  if (loadingEvent) return <div>loading</div>

  return (
    <Layout >
      <Layout.Content style={{ backgroundColor: '#fff' }}>
        <Row>
          <Col md={{ span: 12, offset: 4 }}>
            <h1>Create e-Cer for Virtual Run.</h1>
            <Form onSubmit={handSubmit} {...formItemLayout}>
              <Form.Item label="Event">
                <Select
                  showSearch
                  onChange={(e) => {
                                    const event = events.find(ev => ev._id === e)
                                    setEventId(e)
                                    setSlug(event.slug)
                                }}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {events.map(event => <Select.Option key={event._id} value={event._id}>{event.name.en}</Select.Option>)}
                </Select>
              </Form.Item>

              {races && races.length > 0 ?
                <Form.Item label="Race">
                  <Select
                    onChange={e => setRace(e)}
                  >
                    {races.map(rc => <Select.Option key={rc} value={rc}>{rc}</Select.Option>)}
                  </Select>
                </Form.Item> : null}

              {eventId ?
                <Form.Item label="Bib">
                  <InputNumber
                    min={1}
                    placeholder="Enter Bib"
                    onChange={e => handleBib(e)}
                    value={bib}
                  />
                </Form.Item> : null}

              {eventTicketItemSearch && eventTicketItemSearch.length > 0 ?
                <Form.Item label="name">
                  <Input name="name" value={`${eventTicketItemSearch[0].participant.profile.firstName} ${eventTicketItemSearch[0].participant.profile.lastName}`} disabled />
                </Form.Item> : null}

              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" disabled={disabled} htmlType="submit">Generate</Button>
              </Form.Item>
              <Form.Item {...tailFormItemLayout}>
                {slug && bib ? <div>URL: <a target="_blank" href={`https://ecer.thai.run/${slug}/${bib}`} rel="noopener noreferrer">https://ecer.thai.run/{slug}/{bib}</a></div> : null}
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Layout.Content>
    </Layout>)
}

export default CreateEcer



// WEBPACK FOOTER //
// ./src/CreateEcer/CreateEcer.js